import React, { Component } from "react";
import { withRouter, Link, Redirect } from "react-router-dom";
import Header from "../../components/partials/HeaderComponent";
import Footer from "../../components/partials/FooterComponent";
import CoinImg from "../../assets/img/coin.png";
import "./ProblemList.css";
import {Link as RouterLink} from 'react-router-dom' ; 
import axios from "axios";
import Spinner from '../MerchandiseStore/Spinner/Spinner';
import { connect } from 'react-redux';

const mapDifficulty = {
    "1": "Cakewalk",
    "2": "Easy",
    "3": "Medium",
    "4": "Hard",
    "5": "Miscellaneous" 
}

const convertDate = (d) => {
  if(!d) return "";
  d = new Date(d);
  const day = d.getDate();
  const month = d.getMonth() + 1;
  const year = d.getFullYear();
  return day + '/'  + month + '/' + year;
}

const convertTime = (d) => {
  if(!d) return "";
  d = new Date(d);
  const hours = d.getHours();
  const min = d.getMinutes();
  const sec = d.getSeconds();
  return hours + ':'  + min + ':' + sec;
}

class ProblemList extends Component {
  state = {
    problemList: [],
    contestName: "",
    contestRank: null,
    announcements: null,
    contestEnded: false,
    loading: false,
    isPaid: true,
    practiceAllowed:false,
  };

  async componentDidMount() {
    this.setState({
      loading: true
    })
    
    let currTime = new Date().getTime();
    await axios.get('https://server.codeium.tech/time').then(res => {
      currTime = new Date(res.data.time).getTime();
    })
    .catch(err => {
      // console.log(err);
    })
    let startTime = new Date().getTime();
    await axios.post('https://server.codeium.tech/contest/endtime', {
      username: this.props.username,
      contest_id: this.props.match.params.contestId
    }).then(res => {
      startTime = new Date(res.data.msg[0].start_time).getTime();
      var endTime = new Date(res.data.msg[0].end_time).getTime();
      // console.log(res);
      if (startTime > currTime) {
        // console.log("Yes");
        this.props.history.push("/contests");
      }
      else if (endTime && (currTime - endTime) / 36e5 >= 1) {
        this.setState({
          practiceAllowed: true
        })
      }
    }).catch(err => {
      // console.log(err);
    })
    await axios.post('https://server.codeium.tech/contest/endtime', {
      username: this.props.username,
      contest_id: this.props.match.params.contestId
    }).then(res => {
      let endTime = new Date(res.data.msg[0].end_time).getTime();
      let timeleft = endTime - currTime;
      let interval = setInterval(() => {
        if(timeleft < 0) {
          this.setState({
            contestEnded: true
          })
          clearInterval(interval);
        } else {
          let hours = Math.floor(
            (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          let minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
        
          hours = "0" + hours.toFixed(0);
          minutes = "0" + minutes.toFixed(0);
          seconds = "0" + seconds.toFixed(0);
          this.setState({
            timeRemaining: hours.slice(-2) + ":" + minutes.slice(-2) + ":" + seconds.slice(-2)
          });
          timeleft -= 1000;
        }
      }, 1000);
    }).catch(err => {
      // console.log(err);
    })


    await axios.post('https://server.codeium.tech/contest/problem', {
      username: this.props.username,
      contest_id: this.props.match.params.contestId
    }).then(res => {
      this.setState({
        problemList: res.data.msg,
      });
    }).catch(err => {
      // console.log(err);
    })

    await axios.post('https://server.codeium.tech/contest/announcement', {
      username: this.props.username,
      contest_id: this.props.match.params.contestId
    }).then(res => {
      this.setState({
        announcements: res.data.msg,
      });
    }).catch(err => {
      // console.log(err);
    })

    await axios.post('https://server.codeium.tech/contest/name', {
      username: this.props.username,
      contest_id: this.props.match.params.contestId
    }).then(res => {
      this.setState({
        contestName: res.data.msg[0].contest_name,
      });
    }).catch(err => {
      // console.log(err);
    })

    await axios.post('https://server.codeium.tech/contest/rank', {
      username: this.props.username,
      contest_id: this.props.match.params.contestId
    }).then(res => {
      if (res.data && res.data.status != 420) {
        this.setState({
          currentRank: res.data.msg[0].current_rank,
        });
      }
      else {
        this.props.history.push("/contests");
      }
      // if(res.data.status)
    }).catch(err => {
      // console.log(err);
    })
    
    await axios.post(`https://server.codeium.tech/contest/paid/transaction`, {
      "username": this.props.username,
      "contest_id": this.props.match.params.contestId
    }).then(res => {
      if (res.data.msg.ispaid !== "Success") {
        this.setState({
          isPaid: false
        });
      }
    }).catch(err => {
      // console.log(err);
      this.setState({
        isPaid: false
      });
    })

    this.setState({
      loading: false
    })
  }

  render() {
    if (!this.state.practiceAllowed && !this.state.isPaid) {
      return <Redirect to="/contests"/>
    }
    try {
      return (
        <>
          <Header />
          {
            this.state.loading ? <Spinner/> :
              <div className="container mt-5 ProblemsContainer mb-5">
                <div className="row">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb bg-transparent pb-1">
                      <RouterLink to={"contests"}>
                      <li>
                        <a className="ProblemListLink">Contests</a>
                      </li>
                      </RouterLink>
                      {" >> "}
                      <RouterLink to={"/contests/" + this.props.match.params.contestId + "/"}>
                        <li>
                          <a className="ProblemListLink">
                            {this.state.contestName}
                          </a>
                        </li>
                      </RouterLink>
                      {" >> "}
                      <li class="ProblemListName" aria-current="page">
                        Problems
                    </li>
                    </ol>
                  </nav>
                </div>
                <div className="row">
                  <div className="col-12 ">
                    <h1 className="primary-heading d-inlines py-md-0 py-2 ">
                      {this.state.contestName}
                    </h1>
                  </div>
                  <div className="col-12">
                    <hr className="mt-0" />
                  </div>
                </div>
                <div className="py-2">
                  <h3>
                    <b>Problems</b>
                  </h3>
                </div>
                <div className="row px-md-1 my-3">
                  <div className="col-12 col-md-8 px-0 px-md-2 mx-0">
                    <table className="table Problem_Table">
                      <thead className="thead-light">
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Name</th>
                          <th scope="col">Difficulty</th>
                          <th scope="col">Coins</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.problemList.map((problem, index) => {
                          let styles = {};
                          if (problem.verdict === "WA") {
                            styles = { backgroundColor: "#ffe3e3" };
                          } else if (problem.verdict === "AC") {
                            styles = { backgroundColor: "#d4edc9" };
                          }
                          return (
                            <tr key={problem.problem_id} style={styles}>
                              <th scope="row">{index + 1}</th>
                              <td>
                                <Link
                                  to={
                                    this.props.location.pathname +
                                    "/" +
                                    problem.problem_id
                                  }
                                >
                                  {problem.problem_title}
                                </Link>
                              </td>
                              <td>{mapDifficulty[problem.difficulty_level]}</td>
                              <td>
                                {problem.coins}
                                <img src={CoinImg} className="Cart_CoinImg" />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="card bg-light py-2 px-4">
                      {
                        !this.state.contestEnded ? (
                          <>
                            <h5 className="text-center mt-2 card-title">Contest Ends in</h5>
                            <h5 className=" text-center card-subtitle">
                              {this.state.timeRemaining}
                            </h5>
                          </>
                        ) : <h5 className="text-center mt-2 card-title">Contest has Ended</h5>
                      }
  
                      <hr />
                      <h5 className="text-center mt-2">
                        <b>Current Rank:</b> {this.state.currentRank || "NA"}
                      </h5>
                      <hr />
                      <div></div>
                      <div className="row">
                        <div className="col-6">
                          <h6 className="text-center">
                            <Link className="text-decoration-none" to={this.props.location.pathname + "/leaderboard"}>
                              <b>Leaderboard</b>
                            </Link>
                          </h6>
  
                        </div>
                        <div className="col-6">
                          <h6 className="text-center">
                            <Link className="text-decoration-none" to={this.props.location.pathname + "/submissions/"}>
                              <b>Submissions</b>
                            </Link>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-12 col-md-8">
                    <h4 className="mb-3">
                      <b>Announcements</b>
                    </h4>
                    {!this.state.announcements || this.state.announcements.length === 0 ? (
                      <p>There are no announcements yet</p>
                    ) : (
                      this.state.announcements.map((ann) => {
                        return (
                          <div className="mx-2 my-0">
                            <p className="py-0 my-1">
                              <h6 className="d-inline">
                                <b>{convertDate(ann.time_stamp) + ", " + convertTime(ann.time_stamp)}</b>:
                              {/* <b>{ann.time_stamp}</b>: */}
                              </h6>{" "}
                              {ann.body}
                            </p>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
          }
          <Footer />
        </>
      );
    }
    catch {
      <Redirect to="/" />
    }
  }
}

const mapStateToProps = state => {
  return {
    username: state.auth.username
  }
}

export default connect(mapStateToProps)(withRouter(ProblemList));
